<template>
    <div class="auth-wrapper auth-v1"
         style="padding: 0;">
        <div class="auth-inner main-container-width">
            <v-row v-if="loaded">
                <v-col cols="12"
                       sm="12"
                       md="12"
                       lg="12"
                       class="mx-auto">
                    <v-card flat
                            class="full-min-height pb-10">
                        <app-header :details="selectedCard"></app-header>
                        <v-row class="mx-10 mt-9">
                            <v-col cols="12"
                                   lg="12">
                                <v-row class="backbtn mr-4 pb-8">

                                    <BackAction :text="text"
                                                :output="output" />
                                </v-row>

                                <p class="text-2xl font-weight-semibold text-black"
                                   style="margin-bottom: 0">
                                    {{ $t('Trusted devices') }}
                                </p>
                                <p style="font-size: 14px">
                                    {{ $t(`Card ending -`) }}
                                    {{ this.cardDetails.Last4Digits }}
                                </p>

                            </v-col>
                        </v-row>

                        <div style="padding: 4%;background-color: #F8F8F8;margin: 2%;">

                            <v-card v-for="(item, index) in trustedDevices"
                                    :key="index"
                                    class="mt-3"
                                    style="width: 98%;overflow-x: auto;overflow-y: hidden;">

                                <div class="pa-3"
                                     style="min-width: 700px;">
                                    <v-row style="min-height: 75px;">
                                        <v-col cols="4"
                                               lg="4"
                                               md="4"
                                               sm="4"
                                               class="d-flex">
                                            <div class="d-flex flex-column justify-center">
                                                <div>
                                                    <v-img v-if="item.deviceName == 'Microsoft / PC'"
                                                           contain
                                                           :src="windows">
                                                    </v-img>
                                                    <v-img v-if="item.deviceName == 'Apple'"
                                                           contain
                                                           :src="apple">
                                                    </v-img>
                                                    <v-img v-if="item.deviceName == 'Linux'"
                                                           contain
                                                           :src="windows">
                                                    </v-img>
                                                    <v-img v-if="item.deviceName == 'Android'"
                                                           contain
                                                           :src="windows">
                                                    </v-img>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column justify-center mx-3">
                                                <span class="font-weight-semibold text-black">
                                                    {{ item.deviceName }}
                                                </span>
                                                <div class="text-black font-weight-regular successColor"
                                                     style="font-size:12px;"> {{ item.deviceOSAndVersion }}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="6"
                                               lg="6"
                                               md="6"
                                               sm="6"
                                               class="d-flex">

                                            <v-row>
                                                <v-col cols="1"
                                                       lg="1"
                                                       md="1"
                                                       sm="1">
                                                    <div class="mt-1 mb-1">
                                                        <v-img contain
                                                               :src="browser">
                                                        </v-img>
                                                    </div>
                                                    <div>
                                                        <v-img contain
                                                               :src="location">
                                                        </v-img>
                                                    </div>
                                                </v-col>
                                                <v-col cols="11"
                                                       lg="11"
                                                       md="11"
                                                       sm="11"
                                                       style="padding-left: 0 !important;">
                                                    <div class="mt-1 mb-1 d-flex font-weight-semibold"
                                                         style="height: 30px;color: black">
                                                        <div class="mx-1">{{ item.brand }}</div>
                                                    </div>
                                                    <div class="mt-1 mb-1 d-flex font-weight-regular"
                                                         style="color:#8A8A8A;font-size:13px;height: 30px;">
                                                        <div class="mx-1">{{ item.locationName }}</div>
                                                    </div>
                                                </v-col>
                                            </v-row>

                                        </v-col>


                                        <v-col lg="2"
                                               md="2"
                                               sm="2"
                                               cols="2"
                                               class="d-flex">
                                            <v-btn color="warn"
                                                   type="button"
                                                   style="width: 60%;position: relative;top: 12px; font-size: 14px;background-color: #D92D20;color: white;"
                                                   @click="onRemove($event, item)"
                                                   x-large
                                                   class=" py-3 mb-5">
                                                {{ $t('Remove') }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                            <div class="my-5 text-center"
                                 v-if="trustedDevices.length == 0">
                                <div class="no-offers">

                                    <img style="height: 100px;"
                                         src="@/assets/images/2025/trusteddevices.png"
                                         alt="">
                                    <h2 class="text-color-black mt-1">
                                        {{ $t('No trusted devices yet') }}
                                    </h2>
                                    <p>
                                        {{ $t('Add a device to make sign-ins faster and more secure.') }}
                                    </p>
                                </div>
                            </div>


                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-model="modalConfirmRemove">
            <v-card class="v-dialog-logout"
                    style="margin: 0 auto;overflow: hidden !important;height: 270px;">
                <v-card-title>
                    <span @click="modalConfirmRemove = false"
                          style="position: absolute; right: 10px;cursor: pointer;">
                        <v-icon>
                            {{ icons.mdiClose }}
                        </v-icon>
                    </span>
                </v-card-title>


                <v-card-text>
                    <div class="text-center">
                        <div>
                            <h3 class="font-weight-semibold">
                                {{ $t('Revoke trusted device') }}
                            </h3>
                        </div>
                        <p class="mt-3 text-sm">
                            {{ $t(`Are you sure you want to remove this device from your
                            trusted list? This device will no longer be able to
                            streamline login.`) }}</p>
                    </div>
                </v-card-text>

                <v-row class="mx-6 pb-6">
                    <v-col lg="12">
                        <v-btn block
                               @click="revokeTrustedDevice(selectedDevice)"
                               color="primary"
                               type="submit"
                               large
                               class="">
                            {{ $t('Remove') }}
                        </v-btn>
                    </v-col>
                    <v-col lg="12">
                        <v-btn block
                               type="submit"
                               large
                               style="border: 1px solid #016FD0;"
                               @click="modalConfirmRemove = false">
                            {{ $t('Cancel') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AppHeader from '../test/AppHeader.vue';
import store from '@/store';
import router from '@/router';
import BackAction from '@/@core/BackAction.vue';

import sharedServices from '@/services/shared-services';
import { browser } from 'vue-carousel-3d';
import { mdiClose } from '@mdi/js';
import restErrorMessages from '@/@core/utils/rest-error-messages';

export default {
    components: {
        AppHeader,
        BackAction
    },

    data: () => ({
        selectedCard: null,
        accountCards: [],
        cards: [],
        cardDetail: {
            active: 0,
            inActive: 0,
            block: 0,
            expired: 0,
        },
        cardDetails: null,
        icons: {
            mdiClose,
        },
        text: 'Back to Card Details',
        output: false,
        selectedDevice: null,
        location: require(`@/assets/images/trusted-devices/location.png`),
        browser: require(`@/assets/images/trusted-devices/browser.png`),
        apple: require(`@/assets/images/trusted-devices/apple.png`),
        windows: require(`@/assets/images/trusted-devices/windows.png`),
        trustedDevices: [],
        modalConfirmRemove: false,
        loaded: false,
    }),
    mounted()
    {
        this.accountCards = store.get('cardStore/accountCards');
        this.cards = store.get('cardStore/allCards')
        this.selectedCard = store.get('card/details');
        this.cardDetails = store.get('card/details');

        this.selectedLanguage = localStorage.getItem('language');
        if (this.selectedLanguage == 'ar')
        {
            this.arrowImage = this.arrowLeft;
        }
        else
        {
            this.arrowImage = this.arrowRight;
        }

        this.getTrustedDevices();

        this.loaded = true;
    },

    methods: {
        onRemove(event, item)
        {
            this.modalConfirmRemove = true;
            this.selectedDevice = item;
        },
        selectCard()
        {
            router.push('/card-issue')
        },
        back()
        {
            router.push('/card-detail')
        },
        popup()
        {
            router.push('/primary-card')
        },
        swapCard(event)
        {
            this.selectedCard = store.get('card/details');
        },
        getTrustedDevices()
        {
            sharedServices.getToken('entity', store.get('requestKeys/userName')).then(response =>
            {
                let data = {
                    requestInfo: {
                        channelKey: response.data.results.channelKey,
                        identityKey: response.data.results.identityKey,
                        requestDate: response.data.results.requestDate,
                        requestUID: Math.floor(1000 + Math.random() * 9000).toString(),
                        channelId: store.get('requestKeys/channelId'),
                        userName: store.get('requestKeys/userName'),
                        identitySeed: sharedServices.getIdSeed(),
                    },
                    legalId: store.get('requestKeys/legalId') || "",
                }

                sharedServices.getTrustedDevices(data).then(res =>
                {
                    let errorCode = res?.data?.responseInfo?.errorCode;
                    let errorDescription = res?.data?.responseInfo?.errorDescription;

                    this.trustedDevices = [];

                    if (errorCode == '00000')
                    {
                        this.trustedDevices = res.data?.trustedDevices;
                    }
                    else
                    {
                        if (errorCode == '80020')
                        {
                            errorCode = '989898'
                        }
                        this.showAlert = true
                        this.alertMessage = restErrorMessages.get(errorCode, errorDescription)
                        this.alertType = 'error'
                        setTimeout(() =>
                        {
                            this.showAlert = false
                        }, 5000)
                    }
                    // window.location.reload();
                })
            })
        },
        revokeTrustedDevice(item)
        {
            sharedServices.getToken('entity', store.get('requestKeys/userName')).then(response =>
            {
                let data = {
                    requestInfo: {
                        channelKey: response.data.results.channelKey,
                        identityKey: response.data.results.identityKey,
                        requestDate: response.data.results.requestDate,
                        requestUID: Math.floor(1000 + Math.random() * 9000).toString(),
                        channelId: store.get('requestKeys/channelId'),
                        userName: store.get('requestKeys/userName'),
                        identitySeed: sharedServices.getIdSeed(),
                    },
                    legalId: store.get('requestKeys/legalId') || "",
                    DeviceId: item.deviceID,
                    identitySeed: item.identitySeed
                }

                sharedServices.revokeTrustedDevice(data).then(res =>
                {
                    let errorCode = res?.data?.responseInfo?.errorCode;
                    let errorDescription = res?.data?.responseInfo?.errorDescription;

                    if (errorCode == '00000')
                    {
                        this.trustedDevices.splice(this.trustedDevices.indexOf(item), 1);

                        this.modalConfirmRemove = false;
                        this.selectedDevice = null;

                        this.showAlert = true
                        this.alertMessage = 'Trusted Device Removed Successfully';
                        this.alertType = 'error'
                        setTimeout(() =>
                        {
                            this.showAlert = false
                        }, 5000)
                    }
                    else
                    {
                        if (errorCode == '80020')
                        {
                            errorCode = '989898'
                        }
                        this.showAlert = true
                        this.alertMessage = restErrorMessages.get(errorCode, errorDescription)
                        this.alertType = 'error'
                        setTimeout(() =>
                        {
                            this.showAlert = false
                        }, 5000)

                        if (errorCode == '81051')
                        {
                            this.isOtpGenerated = false;
                        }
                    }
                    // window.location.reload();
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/auth.scss';

.v-application.theme--light .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}

.cut-text {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 146px;
    height: 1.2em;
    white-space: nowrap;
}

.backbtn {
    margin-left: -24px;
}

.area {
    background-color: white;
}

@media (max-width: 500px) {
    .mx-10 {
        margin-right: 11px !important;
        margin-left: 11px !important;
    }
}
</style>
;
